module.exports = __webpack_public_path__ + "assets/img/campaign-image-1.d60a4cbf.png";